export const INK_BOOK_IMG_ASPECT = {
  w: 600,
  h: 420,
};

/**
 * inkKind = 'lecture'
 * slug = 'py-basic'
 * slug는 관리자 페이지의 기초학습 문서등록시 등록하는 정보입니다.
 * lectureKey = 'lecture.py-basic'
 * lectureKey = {inkKind}.{slug or bookId}
 *
 */
export const INK_BASIC_LECTURES = [
  {
    language: 'py',
    lectureKey: 'lecture.py-basic',
  },
  {
    language: 'p5',
    lectureKey: 'lecture.p5-basic',
  },
  {
    language: 'js',
    lectureKey: 'lecture.js-basic',
  },

  {
    language: 'blox',
    lectureKey: 'lecture.blox-basic',
  },
];
